import { useReducer, useRef } from "react";
import AnimatedModal from "../components/AnimatedModal";
import DefaultModal from "../components/DefaultModal";

export const modalActionTypes = {
  show: 'show',
  modalData: 'modalData',
  component: 'component',
  label: 'label',
  modalType: 'modalType',
  modalClassName: 'modalClassName'
};

export const modalTypes = {
  animated: 'animated',
  default: 'default'
};

export function modalReducer(state, action) {
  switch (action.type) {
    case modalActionTypes.modalClassName: {
      return { ...state, modalClassName: action.payload };
    }
    case modalActionTypes.modalType: {
      return { ...state, modalType: action.payload };
    }
    case modalActionTypes.label: {
      return { ...state, label: action.payload };
    }
    case modalActionTypes.component: {
      return { ...state, component: action.payload };
    }

    case modalActionTypes.show: {
      return { ...state, show: !state.show };
    }

    case modalActionTypes.modalData: {
      return { ...state, modalData: action.payload };
    }

    default: {
      throw new Error(`Unsupported Modal Options type: ${action.type}`);
    }
  }
}

export function useModalOptions({ initialState, reducer = modalReducer } = {}) {
  const { current: currentState } = useRef(initialState);
  const [state, dispatch] = useReducer(reducer, currentState);

  const { component, modalType } = state || {};
  const Modal = modalType === modalTypes.animated ? AnimatedModal : DefaultModal;
  const Component = component;

  const updateModalOptions = ({ type, payload }) => dispatch({ type, payload });

  return {
    state,
    Component,
    Modal,
    updateModalOptions,
  };
}
